import React, { memo } from 'react'
import { Grid } from '@mui/material'

import PersonalInfo from './PersonalInfo'
import ChangeEmail from './ChangeEmail'
import ChangePassword from './ChangePassword'
import MoreInfo from './MoreInfo'
import PageContainer from '../shared/PageContainer/PageContainer'

const MyAccount = ({
  accountProfile,
  dispatchAction,
  updatePersonalInfo,
  changeEmailAddress,
  changePassword,
  t
}) => (
  <PageContainer title={t('header.account-settings')}>
    <Grid container>
      <Grid item xs={12} padding={2}>
        <Grid container spacing={0} justifyContent='center'>
          <Grid item xs={12} lg={6}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <PersonalInfo
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={updatePersonalInfo}
                  t={t}
                />
              </Grid>
              <Grid item xs={12}>
                <ChangeEmail
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changeEmailAddress}
                  t={t}
                />
              </Grid>
              <Grid item xs={12}>
                <ChangePassword
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changePassword}
                  t={t}
                />
              </Grid>
              <Grid item xs={12}>
                <MoreInfo t={t} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </PageContainer>
)

export default memo(MyAccount)
